import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { addUpdateReserveEventAPI, fetchReserveApi } from '../../services/reserve-service'
import { FETCH_RESERVE_START,FETCH_RESERVE_SUCCESS, FETCH_RESERVE_ERROR, ADD_UPDATE_RESERVE_EVENT, ADD_UPDATE_RESERVE_EVENT_START, ADD_UPDATE_RESERVE_EVENT_SUCCESS, ADD_UPDATE_RESERVE_EVENT_ERROR, FETCH_RESERVE } from '../actions/reserveActions';

export function* getReserve({ payload }) {
  try {
      yield put({ type: FETCH_RESERVE_START })
      const response = yield call(fetchReserveApi, payload);
      if (response.success) {

          const events = response.data.map(reserve => {
              return {
                  ...reserve,
                  "resourceId": reserve.machineId,
                  "title": reserve.resourceName,
                  "start": reserve.startTime,
                  "end": reserve.endTime
              }
          })

          yield put({ type: FETCH_RESERVE_SUCCESS, events })
      } else {
          yield put({ type: FETCH_RESERVE_ERROR, error: response.error })
          message.error('Failed to fetch reserve!');
      }
  } catch (error) {
      yield put({ type: FETCH_RESERVE_ERROR, error })
      message.error('Failed to fetch reserve!');
  }
}

export function* addUpdateReserveEvent({ payload }) {
  const { event } = payload;
  try {
      yield put({ type: ADD_UPDATE_RESERVE_EVENT_START })
      const response = yield call(addUpdateReserveEventAPI, event);
      if (response.success) {
          const newEvent = {
              ...response.data,
              "resourceId": response.data.machineId,
              "title": event.title,
              "start": response.data.startTime,
              "end": response.data.endTime
          };
          yield put({ type: ADD_UPDATE_RESERVE_EVENT_SUCCESS, event: newEvent })
      } else {
          yield put({ type: ADD_UPDATE_RESERVE_EVENT_ERROR, error: response.error })
          message.error('Failed to add update reserve event!');
      }
  } catch (error) {
      yield put({ type: ADD_UPDATE_RESERVE_EVENT_ERROR, error })
      message.error('Failed to add update reserve event!');
  }
}

function* rosterWatcher() {
  yield takeLatest(FETCH_RESERVE, getReserve)
  yield takeLatest(ADD_UPDATE_RESERVE_EVENT, addUpdateReserveEvent)
}

export default function* rosterSaga() {
  yield all([
      rosterWatcher(),
  ]);
}